import { Link, useParams } from 'react-router';
import { useState } from 'react';

export function Legal() {
  const { eventSlug, formOrder } = useParams();

  // check with regex if formSlug is a number
  const formSlugIsNumber = formOrder && /^\d+$/.test(formOrder);

  // We don't need to render the legal link on the event page
  if (eventSlug && formSlugIsNumber) {
    return null;
  }

  return (
    <div className="flex items-end gap-4 p-1 text-xs text-muted-foreground">
      <Link to="/terms-of-service" target="_blank">
        Terms of Service
      </Link>
      <Link to="/privacy-policy" target="_blank">
        Privacy Policy
      </Link>
    </div>
  );
}
